import { forwardRef, HTMLAttributes, ReactNode } from 'react';

import { StyledBody } from './Body.styles';

export interface BodyProps extends HTMLAttributes<HTMLElement> {
	children?: ReactNode;
}

export const Body = forwardRef<HTMLElement, BodyProps>(({ children, ...props }, ref) => (
	<StyledBody {...props} ref={ref}>
		{children}
	</StyledBody>
));

Body.displayName = 'Body';
